@if (origin(); as ori) {
  <div class="npdc-title">
    <h1>{{ title() }}</h1>
    <div class="npdc-title__actions">
      <button
        mat-icon-button
        [matMenuTriggerFor]="optionsMenu"
        matTooltip="More actions"
        [disabled]="!ori.isPublished"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </div>
  <h2>
    <mat-icon>{{ ori | originIcon }}</mat-icon>
    {{ ori | originAbstract }}
  </h2>

  <app-plankton-propertylist [data]="ori"></app-plankton-propertylist>
  <app-plankton-propertylist [data]="ori.metaInfo" title="Meta info"></app-plankton-propertylist>

  <mat-menu #optionsMenu>
    @switch (ori.darwinCoreClass) {
      @case ('event') {
        <button
          mat-menu-item
          [routerLink]="['/plankton', 'event']"
          [queryParams]="{ originID: ori.id }"
        >
          <mat-icon>list</mat-icon> Show imported events
        </button>
      }
      @case ('occurrence') {
        <button
          mat-menu-item
          [routerLink]="['/plankton', 'occurrence']"
          [queryParams]="{ originID: ori.id }"
        >
          <mat-icon>list</mat-icon> Show imported occurrences
        </button>
      }
    }
  </mat-menu>
}
